import { usePropertyRequiredZoningOrEntitlement } from '../../../../queries/PropertyFields/NonRentalLandFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

interface ZoningOrEntitlementProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const ZoningOrEntitlement: React.FC<ZoningOrEntitlementProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Does the work require any zoning or entitlement changes?';
    const [requiredZoningOrEntitlement, set_requiredZoningOrEntitlement] = usePropertyRequiredZoningOrEntitlement(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_requiredZoningOrEntitlement(true);
                return;
            case 'no':
                set_requiredZoningOrEntitlement(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={requiredZoningOrEntitlement ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='requiredZoningOrEntitlement'
                    value={requiredZoningOrEntitlement}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Required Zoning or Entitlement required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
